import React from 'react';
import { Col, Row } from 'antd';
import { UseCaseConfiguration } from 'components/public/integrations/useHitchConfiguration';
import UseCases from 'components/HitchById/UseCases';
import { useIntl } from 'react-intl';

type QuickLookProps = {
  useCaseConfiguration: UseCaseConfiguration;
};

const QuickLook = ({ useCaseConfiguration }: QuickLookProps): JSX.Element => {
  const { formatMessage } = useIntl();

  const { setSelectedUseCase, selectedUseCase, usecases } = useCaseConfiguration;
  return (
    <Row justify="center" gutter={[32, 32]}>
      <Col span={24}>
        <h2>
          {formatMessage({
            defaultMessage: 'Check out what we can do for you',
            description: 'nextsteps/supported-apps/title',
          })}
        </h2>
        <UseCases
          usecases={usecases}
          onSelectedUseCase={setSelectedUseCase}
          selectedUseCase={selectedUseCase}
        />
      </Col>
    </Row>
  );
};

export default QuickLook;
